<template>
  <form @submit.prevent>
    <div class="pl-lg-4">
      <div class="row">
        <div class="col-lg-4">
          <base-input
            alternative=""
            required
            :label="$t('name_companies')"
            :placeholder="$t('name_companies')"
            input-classes="form-control-alternative border"
            v-model="model.name"
            data-vv-validate-on="blur"
            v-validate="'required'"
            :data-vv-as="$t('name_companies')"
            name="name"
            autocomplete="ÑÖcompletes"
          />
          <span class="text-danger text-sm" v-show="errors.has('name')"
            ><small>{{ errors.first("name") }}</small></span
          >
        </div>
        <div class="col-lg-4">
          <base-input :label="$t('phone')" required>
            <vue-tel-input
              styleClasses="form-control-alternative border p-1 bg-white text-white"
              :inputOptions="{ placeholder: $t('phone'), required: true }"
              :autoDefaultCountry="false"
              :defaultCountry="defaultCountry"
              :dropdownOptions="{
                showFlags: true,
                showDialCodeInSelection: true,
                showDialCodeInList: true,
              }"
              :validCharactersOnly="true"
              v-model="model.phone"
              name="phone"
              ata-vv-validate-on="blur"
              v-validate="'required'"
              :data-vv-as="$t('phone')"
            >
              <template slot="arrow-icon" slot-scope="{ open }">
                <i v-if="open" class="fas fa-angle-up"></i>
                <i v-else class="fas fa-angle-down"></i>
              </template>
            </vue-tel-input>
          </base-input>
          <span class="text-danger text-sm" v-show="errors.has('phone')"
            ><small>{{ errors.first("phone") }}</small></span
          >
        </div>

        <div class="col-lg-4">
          <base-input
            alternative=""
            required
            :label="$t('email')"
            placeholder="jesse@example.com"
            input-classes="form-control-alternative border"
            v-model="model.email"
            data-vv-validate-on="blur"
            v-validate="'required|email'"
            :data-vv-as="$t('email')"
            type="email"
            name="email"
            autocomplete="ÑÖcompletes"
          />
          <span class="text-danger text-sm" v-show="errors.has('email')"
            ><small>{{ errors.first("email") }}</small></span
          >
        </div>
      </div>
    </div>
    <div class="pl-lg-4">
      <div class="row">
        <div class="col-lg-6">
          <base-input
            alternative=""
            required
            :label="$t('username')"
            :placeholder="$t('username')"
            v-model="usernameText"
            input-classes="form-control-alternative border"
            data-vv-validate-on="blur"
            v-validate="'required|alpha_dash'"
            :data-vv-as="$t('username')"
            name="username"
            autocomplete="ÑÖcompletes"
          />
          <span class="text-danger text-sm" v-show="usernameStatus"
            ><small>{{ usernameStatus }}</small></span
          >
          <span class="text-danger text-sm" v-show="errors.has('username')"
            ><small>{{ errors.first("username") }}</small></span
          >
        </div>
        <div class="col-lg-6">
          <base-input
            required
            alternative=""
            :label="$t('contact_full_name')"
            :placeholder="$t('contact_full_name')"
            input-classes="form-control-alternative border"
            v-model="model.contact_full_name"
            name="contact_full_name"
            autocomplete="ÑÖcompletes"
            data-vv-validate-on="blur"
            v-validate="'required'"
            :data-vv-as="$t('contact_full_name')"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('contact_full_name')"
            ><small>{{ errors.first("contact_full_name") }}</small></span
          >
        </div>
      </div>
    </div>
    <!-- NEGOCIOS -->
    <div class="pl-lg-4">
      <div class="row">
        <div class="col-md-12">
          <base-input :label="$t('seller')" required>
            <v-select
              class="form-control-alternative border bg-white p-2 rounded mt-2"
              v-model="model.wp_id"
              :placeholder="$t('seller')"
              autocomplete="ÑÖcompletes"
              :options="sellerOptions"
              name="seller"
              label="name"
              data-vv-validate-on="blur"
              v-validate="'required'"
              :data-vv-as="$t('seller')"
            >
              <template #no-options="{}">
                {{ $t("fail") }}
              </template>
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('seller')"
              ><small>{{ errors.first("seller") }}</small></span
            >
          </base-input>
        </div>
        <!-- DIRECCION -->
        <div class="col-md-12">
          <base-input :label="$t('address')" required>
            <GmapAutocomplete
              @place_changed="setPlace"
              class="form-control border"
              id="address"
              :value="model.address"
            />
            <span class="text-danger text-sm" v-show="valid"
              ><small>{{ $t("required_address") }}</small></span
            >
          </base-input>
        </div>
        <div class="col-lg-6">
          <base-input :label="$t('country')" required>
            <v-select
              class="form-control-alternative border bg-white p-2 rounded mt-2"
              v-model="model.country_id"
              :placeholder="$t('country')"
              autocomplete="ÑÖcompletes"
              :options="countriesOptions"
              @input="updateCities(model.country_id.value)"
              name="country"
              data-vv-validate-on="blur"
              v-validate="'required'"
              :data-vv-as="$t('country')"
            >
              <template #no-options="{}">
                {{ $t("fail") }}
              </template>
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('country')"
              ><small>{{ errors.first("country") }}</small></span
            >
          </base-input>
        </div>
        <div class="col-lg-6">
          <base-input :label="$t('city')" required>
            <v-select
              class="form-control-alternative border bg-white p-2 rounded mt-2"
              v-model="model.city_id"
              autocomplete="ÑÖcompletes"
              :placeholder="$t('city')"
              :options="citiesOptions"
              name="city"
              data-vv-validate-on="blur"
              v-validate="'required'"
              :data-vv-as="$t('city')"
            >
              <template #no-options="{}">
                {{ $t("fail") }}
              </template>
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('city')"
              ><small>{{ errors.first("city") }}</small></span
            >
          </base-input>
        </div>
      </div>
    </div>

    <div class="pl-lg-4">
      <div class="row">
        <div class="col-lg-3">
          <base-input
            alternative=""
            :label="$t('tiktok')"
            :placeholder="$t('tiktok')"
            input-classes="form-control-alternative border"
            v-model="model.tiktok"
            autocomplete="off"
            name="tiktok"
          />
        </div>
        <div class="col-lg-3">
          <base-input
            alternative=""
            :label="$t('twitter')"
            :placeholder="$t('twitter')"
            input-classes="form-control-alternative border"
            v-model="model.twitter"
            autocomplete="off"
            name="twitter"
          />
        </div>
        <div class="col-lg-3">
          <base-input
            alternative=""
            :label="$t('facebook')"
            :placeholder="$t('facebook')"
            input-classes="form-control-alternative border"
            v-model="model.facebook"
            autocomplete="off"
            name="facebook"
          />
        </div>
        <div class="col-lg-3">
          <base-input
            alternative=""
            :label="$t('instagram')"
            :placeholder="$t('instagram')"
            input-classes="form-control-alternative border"
            v-model="model.instagram"
            autocomplete="off"
            name="instagram"
          />
        </div>
        <div
          class="col-sm-12 col-md-12 col-lg-12 mt-4 row justify-content-center"
        >
          <div class="col-4 box">
            <img
              style="max-height: 218px; max-width: 218px"
              :src="preview"
              alt="Users"
            />
            <b-button
              pill
              block
              size="sm"
              variant="outline-primary mt-2"
              id="pick-image"
              >{{ $t("picture") }}</b-button
            >
            <avatar-cropper
              :upload-handler="selectedFile"
              @changed="setFileName"
              trigger="#pick-image"
              :labels="{
                submit: $t('accept'),
                cancel: $t('cancel'),
              }"
              :cropper-options="{
                aspectRatio: 1,
                autoCropArea: 1,
                viewMode: 1,
                movable: false,
                zoomable: false,
              }"
            />
          </div>
          <div class="col-4 box">
            <img
              style="max-height: 218px; max-width: 218px"
              :src="logo"
              alt="Users"
            />
            <b-button
              pill
              block
              size="sm"
              variant="outline-primary mt-2"
              id="pick-logo"
              >{{ $t("logo") }}</b-button
            >
            <avatar-cropper
              :upload-handler="selectedLogo"
              @changed="setFileLogo"
              trigger="#pick-logo"
              :labels="{
                submit: $t('accept'),
                cancel: $t('cancel'),
              }"
              :cropper-options="{
                aspectRatio: 1,
                autoCropArea: 1,
                viewMode: 1,
                movable: false,
                zoomable: false,
              }"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <base-button type="primary" class="my-4" @click="add">{{
        $t("save")
      }}</base-button>
    </div>
  </form>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import AvatarCropper from "vue-avatar-cropper";
import helpers from "@/services/helpers";
import _ from "lodash";
import GoogleMap from "@/components/Places.vue";
import { myRendeImage } from "@/directives/render-Image";
export default {
  mixins: [myRendeImage],
  components: {
    AvatarCropper,
    GoogleMap,
  },
  watch: {
    fileSelected() {
      this.valid = this.logoSelected ? false : true;
    },
    usernameText() {
      this.debouncedGetAnswer();
    },
    "model.address": {
      handler() {
        if (this.model.address) {
          this.valid = 0;
        } else {
          this.valid = 1;
        }
      },
    },
  },
  props: {
    data: {
      type: Object,
      default: {},
    },
  },
  async created() {
    this.geolocate();
    this.getSeller();
    this.debouncedGetAnswer = _.debounce(this.username, 400);
    await this.getCountries();
    await this.syncData();
  },
  watch: {
    data() {
      this.syncData();
    },
  },
  data() {
    return {
      model: {
        id: null,
        name: "",
        email: "",
        phone: "",
        address: "",
        username: "",
        contact_full_name: "",
        facebook: "",
        instagram: "",
        tiktok: "",
        twitter: "",
        city_id: null,
        country_id: "",
        picture: null,
        logo: null,
        wp_id: "",
      },
      address: "",
      usernameText: "",
      usernameStatus: null,
      valid: true,
      fileSelected: null,
      logoSelected: null,
      preview: require("@/assets/img/brand/no-image.jpg"),
      logo: require("@/assets/img/brand/no-image.jpg"),
      center: { lat: 45.508, lng: -73.587 },
      valid: 1,
    };
  },
  methods: {
    ...mapActions({
      createCompany: "submitCompany",
      getCountries: "config/getCountry",
      getCities: "config/getCities",
      getUsername: "getUsername",
      getSeller: "config/getSeller",
    }),
    async syncData() {
      if (this.data.id) {
        this.model = {
          id: this.data.id,
          name: this.data.name,
          email: this.data.email,
          phone: this.data.phone,
          address: this.data.address,
          username: this.data.username,
          contact_full_name: this.data.contact_full_name,
          facebook: this.data.facebook,
          instagram: this.data.instagram,
          tiktok: this.data.tiktok,
          twitter: this.data.twitter,
          city_id: this.data.city
            ? {
                value: this.data.city.id,
                label: this.data.city.name,
              }
            : "",
          country_id: this.data.city.country
            ? (this.data.city.country = {
                value: this.data.city.country.id,
                label: this.data.city.country.name,
              })
            : "",
          picture: null,
          logo: null,
          wp_id: this.data.vendor
            ? {
                id: this.data.vendor.id,
                name: this.data.vendor.name,
              }
            : "",
        };
        this.usernameText = this.data.username;
        this.preview = this.imageData(this.data.picture);
        this.logo = this.imageData(this.data.logo);
      } else {
        (this.model = {
          id: null,
          name: "",
          email: "",
          phone: "",
          address: "",
          username: "",
          contact_full_name: "",
          facebook: "",
          instagram: "",
          tiktok: "",
          twitter: "",
          city_id: null,
          country_id: "",
          picture: null,
          logo: null,
          wp_id: "",
        }),
          (this.preview = require("@/assets/img/brand/no-image.jpg"));
        this.logo = require("@/assets/img/brand/no-image.jpg");
      }
    },
    async setPlace(place) {
      this.model.address = place.formatted_address;
      this.center = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };
    },
    geolocate() {
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
      });
    },
    async updateCities(id) {
      await this.getCities(id);
    },
    filesChange(files) {
      this.model.picture = files;
    },
    setFileName(file) {
      this.fileSelected = file;
      this.model.picture = file;
    },
    setFileLogo(file) {
      this.logoSelected = file;
      this.model.logo = file;
    },
    selectedFile(cropper) {
      const dataUrl = cropper
        .getCroppedCanvas()
        .toDataURL(this.fileSelected.type);
      const file = helpers.dataURLtoFile(dataUrl, this.fileSelected.name);
      this.preview = dataUrl;
      this.model.picture = file;
    },
    selectedLogo(cropper) {
      const dataUrl = cropper
        .getCroppedCanvas()
        .toDataURL(this.logoSelected.type);
      const file = helpers.dataURLtoFile(dataUrl, this.logoSelected.name);
      this.logo = dataUrl;
      this.model.logo = file;
    },
    async username(params) {
      const res = await this.getUsername({
        username: params,
        is_creating: this.model.id ? 1 : 0,
        company_id: this.model.id,
      });
      this.usernameStatus = res == !0 ? this.$t("username_fail") : null;
    },
    async add() {
      try {
        const validation = await this.$validator.validateAll();
        if (validation) {
          const payload = {
            id: this.model.id,
            name: this.model.name,
            email: this.model.email,
            phone: this.model.phone,
            address: this.model.address,
            contact_full_name: this.model.contact_full_name,
            username: this.usernameText,
            facebook: this.model.facebook,
            instagram: this.model.instagram,
            tiktok: this.model.tiktok,
            twitter: this.model.twitter,
            city_id: this.model.city_id ? this.model.city_id.value : null,
            picture: this.model.picture,
            latitude: this.center.lat,
            longitude: this.center.lng,
            logo: this.model.logo,
            wp_id: this.model.wp_id.id,
          };
          const res = await this.createCompany(payload);
          if (res.status === 201) {
            this.$toast.success(res.message, {
              position: "top-right",
            });
            this.$router.push("/companies");
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  computed: {
    ...mapGetters({
      countries: "config/countries",
      cities: "config/cities",
      sellerOptions: "config/seller",
    }),
    countriesOptions() {
      if (this.countries) {
        if (this.countries.data) {
          return this.countries.data.map(({ id: value, name: label }) => ({
            value,
            label,
          }));
        }
      }
      return [];
    },
    citiesOptions() {
      if (this.cities) {
        if (this.cities.data) {
          return this.cities.data.map(({ id: value, name: label }) => ({
            value,
            label,
          }));
        }
      }
      return [];
    },
    defaultCountry() {
      let country = localStorage.getItem("Content-Country");
      return JSON.parse(country).iso;
    },
  },
};
</script>
<style scoped>
.ap-footer {
  display: none !important;
}
</style>
<style>
.vs__dropdown-toggle {
  border: none;
}
.vs__search {
  color: rgb(189, 189, 189);
}
.vti__input::-webkit-input-placeholder {
  color: rgb(189, 189, 189) !important;
}
.vti__input {
  color: grey;
}
.vti__country-code {
  margin-right: 4px;
}

@supports (object-fit: cover) {
  .box img {
    height: 100%;
    object-fit: cover;
    object-position: center center;
  }
}
</style>
<style>
.vti__dropdown-item {
  color: black !important;
}
</style>